export const schoolGrades = {
    // 꿈미학교
    4257: [1,2,3,4,5,6,7,8,9,10],
    // 호치민 국제학교
    4322: [1,2,3,4,5,6,7,8,9,10],

}